import RecognitionOutlet from "./RecognitionOutlet";

export default RecognitionOutlet;
